<!--
 * @Description: 登录（PC3.0）
 * @Author:  wang.y
-->
<template>
  <Modal v-model="modelIndex" width="530" class="login-model" @on-cancel="close" @on-visible-change="resetForms" :footer-hide="true">
    <div class="container-wrapper">
      <img :src="static_img_url + 'pic/modal-bg.png?v=' + $store.state.imgVersion" class="model-bg" v-if="language == 'zh'"/>
      <img :src="static_img_url + 'pic/modal-bg-en.png?v=' + $store.state.imgVersion" class="model-bg" v-else/>
      <div class="container-content" v-show="pageStatus == 1">
        <div class="container-top">
          <div class="container-title">{{'欢迎使用VB100观众登录系统' | dealLanguage('Welcome to the VB100 system')}}</div>
          <Form ref="code-form" :model="codeForm" :rules="ruleValidate" v-show="loginWay == 'code-form'">
            <FormItem prop="mobile">
              <div class="mobile-ipt">
                <Dropdown placement="bottom-start" @on-click="handleChangeNumber">
                  <div class="area-number ">
                    <span>+{{loginNumber.mobileAreaCode}} ({{loginNumber.countryName | dealLanguage(loginNumber.countryEnName)}})</span>
                    <i class="iconfont">&#xe669;</i>
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem :name="item.id" v-for="item in appMobileAreaCodeDtos" :key="item.id">+{{item.mobileAreaCode}} ({{item.countryName | dealLanguage(item.countryEnName)}})</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <Input type="text" v-model="codeForm.mobile" :placeholder="'请输入手机号' | dealLanguage('Please enter mobile phone number')" autocomplete="off"></Input>
              </div>
            </FormItem>
            <FormItem prop="code">
              <Input type="text" v-model="codeForm.code" :placeholder="'请填写验证码' | dealLanguage('Please fill in the verification code')" autocomplete="off"></Input>
              <Captcha
                ref="captcha"
                scene="vbdata_loginon"
                :mobile="codeForm.mobile"
                :mobileAreaCode="loginNumber.mobileAreaCode"
                v-if="modelIndex && pageStatus == 1"
              ></Captcha>
            </FormItem>
          </Form>
          <div class="code-app" v-show="loginWay == 'wxcode'">
            <p class="linp1">{{'打开' | dealLanguage('Open')}}<span class="wx">{{'微信' | dealLanguage('WeChat')}}</span>
              <br />{{'扫码关注公众号登录' | dealLanguage('Scan the QR code to follow the official account and log in')}}
            </p>
            <div class="wxcode-img">
              <img :src="codeImg" v-if="codeImg" />
              <div class="wxcode-p" v-if="codeOut" @click="getQrCode">
                <p>{{'二维码已过期' | dealLanguage('The QR code has expired')}}</p>
                <a>{{'刷新' | dealLanguage('Refresh')}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="container-bottom">
          <div class="other">
            <div class="other-font">
              <span>{{'其他登录方式' | dealLanguage('Other login methods')}}</span>
            </div>
            <div class="other-list">
              <div class="other-icon" @click="handleChangeStatus('wxcode', 1)" v-if="loginWay == 'code-form'">
                <img :src="static_img_url + 'pic/wechat-icon.png?v=' + $store.state.imgVersion" />
              </div>
              <div class="other-btn" @click="handleChangeStatus('code-form', 1)" v-if="loginWay == 'wxcode'">{{'验证码登录' | dealLanguage('Verification code login')}}</div>
            </div>
          </div>
          <template v-if="loginWay != 'wxcode'">
            <p class="tip">{{'未注册的手机号将自动创建动脉网账号' | dealLanguage('Unregistered mobile phone numbers will automatically create an VB100 account')}}</p>
            <Button class="submit-btn" type="primary" @click="handleSubmit">{{'登录' | dealLanguage('Log in')}}</Button>
          </template>
          <div class="checkbox-container">
            <div class="checkbox-tip-content" v-if="visible">
              <div class="checkbox-tip-arrow"></div>
              <div class="checkbox-tip-inner">{{'请阅读并勾选下方协议' | dealLanguage('Please read and check the agreement below')}}</div>
            </div>
            <Checkbox v-model="readSingle" size="small" @on-change="visible = false">
              <p class="checkbox-label">{{'我已阅读并同意' | dealLanguage('I have read and agreed to')}}<a :href="index2_path+'/mobile/privacyPolicy/2'" target="_blank">《动脉网用户协议》</a></p>
            </Checkbox>
          </div>
          <div class="checkbox-container">
            <div class="checkbox-tip-content" v-if="visible2">
              <div class="checkbox-tip-arrow"></div>
              <div class="checkbox-tip-inner">{{'请阅读并勾选下方协议' | dealLanguage('Please read and check the agreement below')}}</div>
            </div>
            <Checkbox v-model="readSingle2" size="small" @on-change="visible2 = false">
              <p class="checkbox-label">{{'我已阅读并同意' | dealLanguage('I have read and agreed to')}}<a :href="index2_path+'/mobile/privacyPolicy/1'" target="_blank">《隐私政策》</a></p>
            </Checkbox>
          </div>
        </div>
      </div>
      <div class="container-content" v-show="pageStatus == 2">
        <div class="container-top">
          <div class="container-title reset-form-title">{{'绑定手机号' | dealLanguage('Bind mobile phone number')}}</div>
          <Form ref="biding-form" :model="bidingMobileForm" :rules="ruleValidate">
            <FormItem prop="mobile">
              <div class="mobile-ipt">
                <Dropdown placement="bottom-start" @on-click="handleChangeNumber">
                  <div class="area-number ">
                    <span>+{{loginNumber.mobileAreaCode}} ({{loginNumber.countryName | dealLanguage(loginNumber.countryEnName)}})</span>
                    <i class="iconfont">&#xe669;</i>
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem :name="item.id" v-for="item in appMobileAreaCodeDtos" :key="item.id">+{{item.mobileAreaCode}} ({{item.countryName | dealLanguage(item.countryEnName)}})</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <Input type="text" v-model="bidingMobileForm.mobile" :placeholder="'请输入手机号' | dealLanguage('Please enter mobile phone number')" autocomplete="off"></Input>
              </div>
            </FormItem>
            <FormItem prop="code">
              <Input type="text" v-model="bidingMobileForm.code" :placeholder="'请填写验证码' | dealLanguage('Please fill in the verification code')" autocomplete="off"></Input>
              <Captcha
                ref="captcha"
                scene="vbdata_bidingmobile"
                :mobile="bidingMobileForm.mobile"
                :mobileAreaCode="loginNumber.mobileAreaCode"
                v-if="modelIndex && pageStatus == 2"
              ></Captcha>
            </FormItem>
          </Form>
        </div>
        <div class="container-bottom">
          <Button class="submit-btn" type="primary" @click="bidingMobile">{{'确定绑定' | dealLanguage('Binding')}}</Button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import {
  Alogin,
  AqrCodeCreateTmpTicket,
  Aaccountbinding,
} from '@/service/app'
import {
  editXuserChannel
} from '@/service/vbef'
import Captcha from '@/components/common/captcha'
import { loginCommon } from '@/assets/js/login'
import QRCode from 'qrcode'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  mixins: [loginCommon],
  inject: ['reload', 'checkIfThereAreSendTickets'],
  components: { Captcha },
  data() {
    return {
      modelIndex: false,
      pageStatus: 1,
      loginWay: 'code-form',
      codeForm: {
        mobile: '',
        code: '',
      },
      bidingMobileForm: {
        mobile: '',
        code: '',
      },
      codeInterval: '',
      codeImg: '',
      sceneId: '',
      bidingUser: '',
      codeTime: 0,
      codeOut: 0,
      loginNumber: {
        id: 1,
        mobileAreaCode: '86',
        countryName: '中国',
        countryEnName: 'China'
      }
    }
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    loginSuccess(data) {
      if (data.loginFlag == 2) {
        this.$Message.error(this.language == 'zh' ? '请绑定手机号码' : 'Please bind your mobile phone number')
        this.handleChangeStatus('biding-form', 2)
        this.bidingUser = { ...data.xuser }
        return false
      }
      this.$Message.success(this.language == 'zh' ? '登录成功' : 'Login successful')

      this.$store.commit('updateUserKey', data.userKey)
      this.$store.commit('updateUser', data.xuser)
      this.$store.commit('setUUserId', data.xuser.id)
      // return
      this.modelIndex = false
      document.body.removeAttribute('style')

      this.reload()
      this.checkIfThereAreSendTickets()

      const localsharechannel = localStorage.getItem('sharechannel') || 0
      if(localsharechannel) {
        this.editXuserChannel(localsharechannel)
      }
      if(this.successCb) this.successCb()
    },
    async editXuserChannel(localsharechannel) {
      let res = await editXuserChannel({
        actId: this.$store.state.activityId,
        channelId: localsharechannel,
      })
    },
    resetForms(value) {
      if (!value) {
        this.loginWay = 'code-form'
        this.pageStatus = 1
        this.successCb = ''
        this.clearForms()
      }
    },
    clearForms() {
      clearInterval(this.codeInterval)
      this.$refs['code-form'].resetFields()
      this.$refs['biding-form'].resetFields()
      this.loginNumber = {
        ...{
          id: 1,
          mobileAreaCode: '86',
          countryName: '中国',
          countryEnName: 'China'
        },
      }
      this.visible = false
      this.visible2 = false
      this.codeImg = ''
      this.codeTime = 0
      this.codeOut = 0
      this.readSingle = false
      this.readSingle2 = false
      this.codeStatus = 0
      this.wait = 60
      clearInterval(this.waitInterval)
    },
    handleChangeStatus(name, value) {
      this.loginWay = name
      this.pageStatus = value
      this.clearForms()
      // console.log(this.pageStatus)
      if (name == 'wxcode') {
        this.readSingle = true
        this.readSingle2 = true
        this.getQrCode()
      }
      this.$forceUpdate()
    },
    async getQrCode() {
      let res = await AqrCodeCreateTmpTicket({
        appid: this.loginWxAppId,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'sceneId', res.data.sceneId)
        QRCode.toDataURL(res.data.url, { margin: 1 }).then((url) => {
          this.codeImg = url
        })
        this.codeTime = 0
        this.codeOut = 0
        this.codeInterval = setInterval(this.wxCodeLogin, 2000)
      }
    },
    async wxCodeLogin() {
      this.codeTime++
      if (this.codeTime >= 120) {
        this.codeOut = 1
        clearInterval(this.codeInterval)
        return
      }
      let res = await Alogin({
        appId: this.loginWxAppId,
        code: this.sceneId,
        type: 5,
        loginPlatform: 6,
      })
      if (res.code == 2001002011) return
      clearInterval(this.codeInterval)
      if (res.code == 0) {
        this.loginSuccess(res.data)
      } else {
        this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    bidingMobile() {
      this.$refs['biding-form'].validate(async (valid) => {
        if (valid) {
          let res = await Aaccountbinding({
            code: this.bidingMobileForm.code,
            mobile: this.bidingMobileForm.mobile,
            mobileAreaCode: this.loginNumber.mobileAreaCode,
            type: 2,
            xuser: this.bidingUser,
          })
          if (res.code == 0) {
            this.loginSuccess(res.data)
          } else {
            this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
          }
        }
      })
    },
    handleChangeNumber(value) {
      let item = this.appMobileAreaCodeDtos.find((a) => a.id == value)
      this.loginNumber = { ...item }

      // this.updateRuleValidate()
    },
  },
  created() {
    // this.updateRuleValidate()
  },
  mounted() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/login.styl'
</style>